<ion-app>
  <div class="ion-app-cont">
    <ion-router-outlet>
      <robex-activity-indicator />
    </ion-router-outlet>
  </div>
</ion-app>
